import { render, staticRenderFns } from "./ClientChatShareHandler.vue?vue&type=template&id=68ac0573&scoped=true&"
import script from "./ClientChatShareHandler.vue?vue&type=script&lang=js&"
export * from "./ClientChatShareHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac0573",
  null
  
)

export default component.exports